export class CreateNewArraysDTO{
    labID: string;
    plateIDs: Array<string>;
}

export class CompleteBeadchipAndSourcePlatesDTO{
    labID: string;
    arrayID: string;
    sourcePlateIDs: Array<string>;
    singleRedoSamples: Array<string>;
    deliveredSamples: Array<string>;
    plateRedoSamples: Array<string>;
    plateCompleteList: Array<string>;
    mergeSourcePlateRedoList?: Array<string>;
    plateRedoList: Array<any>;
    puid: string;
}

export class ReportingFileNameDTO{
    labID: string;
    plateID: string;
    reportingFileName: string;
}

export enum EvaluationComparators{
    CALL_RATE = "callRate",
    QC_CALL_RATE = "qcCallRate",
    DQC = "dqc"
}

export enum CircleColors{
    RED = "#ED1C24",
    FFC90E = "#FFC90E",
    GREY = "#C3C3C3",
    WHITE = "#FFFFFF",
    YELLOW = "#F2FF00",
    GREEN = "#B5e61D",
    F06292 = "#F06292",
    LIGHT_GREY = "#555555"
}

export class SingleSamplesRedoDTO{
    labID: string;
    plateID: string;
    redoPositions: Array<string>;
}


export class PlateUpdateDTO{
    labID: string;
    plateID: string;
    status: string;
    puid: string;
    stepName: string;
    stepStart: boolean;
    stepEnd: boolean;
    actionName: string;
    actionRunTime: number;
    addAction: boolean;
}